import Vue, { CreateElement, VNode, VueConstructor } from "vue";
import { getContextModules, getComponent } from "@/lib/requireContextHelpers";

export interface CryptoButton {
  name: string;
  title: string;
  icon?: string;
}

const modules = getContextModules<
  unknown,
  { component: VueConstructor<Vue>; cryptoButton: CryptoButton; cryptoPageTitle: string }
>(require.context("./components", true, /\.\/[a-zA-Z]*\/index.ts/));

export function getCryptoButtons() {
  return modules.map(module => module.default.cryptoButton);
}

export default (cryptoPaymentSystem: string | null) =>
  getComponent(modules, cryptoPaymentSystem, {
    component: Vue.extend({
      render(h: CreateElement): VNode {
        return h();
      },
    }),
    cryptoButton: { name: "", title: "" },
    cryptoPageTitle: "",
  });
